import { CheckCircle2, XCircle } from "lucide-react";

interface PasswordMatchIndicatorProps {
  password: string;
  confirmPassword: string;
}

const PasswordMatchIndicator = ({ password, confirmPassword }: PasswordMatchIndicatorProps) => {
  // Only show indicator when confirm password has content
  if (!confirmPassword) return null;
  
  const matches = password === confirmPassword;
  
  return (
    <div className={`flex items-center gap-1.5 mt-1 text-sm animate-fade-in ${matches ? 'text-green-500' : 'text-destructive'}`}>
      {matches ? (
        <>
          <CheckCircle2 className="h-4 w-4" />
          <span>Passwords match</span>
        </>
      ) : (
        <>
          <XCircle className="h-4 w-4" />
          <span>Passwords don't match</span>
        </>
      )}
    </div>
  );
};

export default PasswordMatchIndicator;
